import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'aft-not-found',
    templateUrl: './not-found.component.html',
    styleUrls: ['../shared/error-base.component.scss', './not-found.component.scss'],
    standalone: false,
})

export class NotFoundComponent {
  public logoPath = '../../../assets/img/frogo.svg';

  constructor(private router: Router) {}

  public navigateToStartPage(): void {
    this.router.navigate(['']);
  }
}
